// Indirection over window.location so the redirect target is observable in tests.
// jsdom makes window.location unforgeable, so the assignment cannot be stubbed from a spec.
export const redirectTo = (url: string): void => {
  window.location.href = url;
};
